import styleInject from '#style-inject';styleInject(".typebot-iframe{width:100%;height:100%;border:none;border-radius:inherit}\n")